import { createRoute } from '@tanstack/react-router'
import { Route as appLayoutRoute } from '../layout'

export const Route = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/my/profile',
}).lazy(() => import('./profile.lazy').then((d) => d.Route))
